import { css } from '@emotion/react';

export const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;
